module.exports = __webpack_public_path__ + "img/info.9223340f.svg";